import { Alert, Card, Nav, Spinner } from 'react-bootstrap';
import classNames from 'classnames';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

const STEPS = [
  { id: 1, label: 'اطلاعات' },
  { id: 2, label: 'رقیب' },
  { id: 3, label: 'پرامپت' },
];

export function SetupStepper({ currentStep }: { currentStep: number }) {
  return (
    <Card className="theme-wizard mb-4">
      <Card.Header className="bg-body-tertiary">
        <Nav className="justify-content-center flex-nowrap overflow-auto">
          {STEPS.map((step) => (
            <StepperNavItem
              key={step.id}
              index={step.id}
              currentStep={currentStep}
              label={step.label}
            />
          ))}
        </Nav>
      </Card.Header>
    </Card>
  );
}

function StepperNavItem({
  index,
  currentStep,
  label,
}: {
  index: number;
  currentStep: number;
  label: string;
}) {
  const done = currentStep > index;

  return (
    <Nav.Item>
      <Nav.Link
        className={classNames('fw-semibold', { done, active: currentStep === index })}
        onClick={() => {}}
      >
        <span className="nav-item-circle-parent p-0 p-md-1">
          {done ? (
            <span className="nav-item-circle">
              <FontAwesomeIcon icon="check" />
            </span>
          ) : currentStep === index ? (
            <span className="nav-item-circle">
              <Spinner
                animation="border"
                role="status"
                style={{ color: 'var(--falcon-primary-text-emphasis, #fff)', verticalAlign: 'middle' }}
              />
            </span>
          ) : (
            <span className="nav-item-circle">
              <FontAwesomeIcon icon="check" />
            </span>
          )}
        </span>
        <span className="d-none d-md-block mt-1 fs-10">{label}</span>
      </Nav.Link>
    </Nav.Item>
  );
}

export function SetupDoneCard({ title, description }: { title: string; description: string }) {
  return (
    <Alert variant="success" className="mb-0">
      <Alert.Heading as="h3" className="fs-0 fw-semibold mb-2" style={{ color: 'inherit' }}>
        {title}
      </Alert.Heading>
      <p className="fs--1 lh-base mb-0 opacity-75">{description}</p>
    </Alert>
  );
}
